import React from "react";
import "./Partners.css";

export default function Partners() {
  const partners = [
    { name: "Evolution Gaming", logo: "/Evolution.png" },
    { name: "PGSoft", logo: "/PGSoft.png" },
    { name: "Ezugi", logo: "/Ezugi.png" },
    { name: "Spribe", logo: "/Spribe.png" },
    { name: "Jili", logo: "/Jili.png" },
    { name: "TurboGames", logo: "/TurboGames.png" },
  ];

  return (
    <section id="partners" className="partners-section">
      <div className="container">
        <div className="section-header">
          <div className="section-badge">Our Network</div>
          <h2 className="section-title">
            Trusted <span className="gradient-text">Partners</span>
          </h2>
          <p className="section-subtitle">
            Powering success through strategic partnerships
          </p>
        </div>

        <div className="partners-grid">
          {partners.map((partner, i) => (
            <div key={i} className="partner-card" data-index={i}>
              <div className="partner-logo-wrapper">
                <img src={partner.logo} alt={partner.name} className="partner-logo" />
              </div>
              <div className="partner-name">{partner.name}</div>
              <div className="card-shine"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

